module.exports = __webpack_public_path__ + "static/media/human-news.5ab4bc05.png";